import { makeStyles } from '@material-ui/core';
import { EItemType } from 'mdello-client-ts/dist/src/interfaces/providers/ecommerce/item.interface';
import { FC } from 'react';

interface ItemPersonalizedBodyProps {
  order: any;
  type: EItemType;
}

const useStyles = makeStyles({
  gridItem: {
    maxWidth: '90%',
    textAlign: 'start'
  },
  p: {
    color: '#9BA0AD',
    fontFamily: 'Poppins',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    lineHeight: '100%'
  },
  span: {
    fontFamily: 'Poppins',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 500
  }
});

const ItemPersonalizedBody: FC<ItemPersonalizedBodyProps> = ({ type, order }) => {
  const classes = useStyles();

  const checkAvailability = (endDateString: string, endTimeString: string) => {
    if (endDateString === '-' || endTimeString === '-') {
      return '-';
    }

    const now = new Date();
    const targetTime = new Date(`${endDateString} ${endTimeString}`);

    if (now > targetTime) {
      return 'Canceled';
    }
    return 'Active';
  };

  if (!type) {
    return (
      <>
        <div className={classes.gridItem}>
          <p className={classes.p}>Brand</p>
          <span className={classes.span}>{order?.brand || '-'}</span>
        </div>

        <div className={classes.gridItem}>
          <p className={classes.p}>Gender</p>
          <span className={classes.span}>{order?.gender || '-'}</span>
        </div>

        <div className={classes.gridItem}>
          <p className={classes.p}>Condition</p>
          <span className={classes.span}>{order?.condition || '-'}</span>
        </div>

        <div className={classes.gridItem}>
          <p className={classes.p}>Item Weight</p>
          <span className={classes.span}>{order?.weight || '-'}</span>
        </div>
      </>
    );
  }

  switch (type) {
    case EItemType.ticket:
      return (
        <>
          <div className={classes.gridItem}>
            <p className={classes.p}>Organizer</p>
            <span className={classes.span}>{order?.profile?.fullName || '-'}</span>
          </div>

          <div className={classes.gridItem}>
            <p className={classes.p}>Event start day&time</p>
            <span className={classes.span}>
              {`${order?.metadata?.startDate || '-'} / ${order?.metadata?.startTime || '-'}`}
            </span>
          </div>
          <div className={classes.gridItem}>
            <p className={classes.p}>Event start day&time</p>
            <span className={classes.span}>
              {`${order?.metadata?.endDate || '-'} / ${order?.metadata?.endTime || '-'}`}
            </span>
          </div>

          <div className={classes.gridItem}>
            <p className={classes.p}>Status</p>
            <span className={classes.span}>
              {checkAvailability(order?.metadata?.endDate || '-', order?.metadata?.endTime || '-')}
            </span>
          </div>
        </>
      );

    default:
      return (
        <>
          <div className={classes.gridItem}>
            <p className={classes.p}>Seller</p>
            <span className={classes.span}>{order?.profile?.fullName || '-'}</span>
          </div>

          <div className={classes.gridItem}>
            <p className={classes.p}>Sellers working day&time</p>
            <span className={classes.span}>
              {`${order?.metadata?.days || '-'}, ${order?.metadata?.startTime || '-'}AM - ${
                order?.metadata?.endTime || '-'
              }PM`}
            </span>
          </div>

          <div className={classes.gridItem}>
            <p className={classes.p}>Status</p>
            <span className={classes.span}>{order?.options?.[0]?.qty ? 'Active' : 'Inactive'}</span>
          </div>
        </>
      );
  }
};

export default ItemPersonalizedBody;
